var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.59375,24.5L18.4042969,3.3881836C17.9023438,2.519043,17.0039062,2,16,2 c-1.0048828,0-1.9042969,0.519043-2.4052734,1.3881836L1.4052734,24.5C1.1386719,24.9624023,0.9980469,25.4819336,1,26.0019531 C1.0029297,27.6552734,2.3505859,29,4.0039062,29h23.9912109C29.6484375,29,30.9970703,27.6552734,31,26.0029297 C31.0019531,25.4829102,30.8613281,24.9633789,30.59375,24.5z M27.9951172,27H4.0039062 C3.3847656,27,3.0009766,26.4799805,3,25.9970703C2.9990234,25.8261719,3.0458984,25.6586914,3.1376953,25.5L15.3271484,4.3876953 C15.5292969,4.0375977,15.8652344,4,16,4s0.4697266,0.0375977,0.671875,0.3881836L28.8613281,25.5 C28.9541016,25.6601562,29.0009766,25.8271484,29,25.9980469C28.9990234,26.4799805,28.6142578,27,27.9951172,27z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 11,
    width: 2,
    height: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 22.5,
    r: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningSmall);
export default __webpack_public_path__ + "static/media/warning--small.ba63b8118fcf8cea6c31534ec29efe9c.svg";
export { ForwardRef as ReactComponent };